export default {"src":"/_next/static/media/skillz_logo_gradient_whiteMark.81ad1455.svg","height":39,"width":39,"blurWidth":0,"blurHeight":0};